const translations = () => {
  return (word, language) => {
    const defaultConfig = require(`./config/en`);
    let translatedWord;

    try{
      const config = require(`./config/${language}`);
      translatedWord = config?.default[word] ?? defaultConfig.default[word];
    }catch{
      translatedWord = defaultConfig.default[word] || word;
    }

    return translatedWord || word;
  }
}

export default translations();
